module.exports = __webpack_public_path__ + "static/media/ball-location.776e0688.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/ball-location.png
// module id = 3599
// module chunks = 0